/*********** Reduceres defined here *********/

import { persistCombineReducers } from "redux-persist";
import storage from "redux-persist/es/storage"; // default: localStorage if web, AsyncStorage if react-native

// reducers
import user from "./modules/user";
import loader from "./modules/loader";
import logo from "./modules/logo";
import search from "./modules/search";
import { createBrowserHistory } from "history";

/*********** History function **************/
export const history = createBrowserHistory();

const userPersistConfig = {
  key: "admin-app",
  storage: storage,
  blacklist: ["router", "loader"],
};

export default persistCombineReducers(userPersistConfig, {
  router: history,
  loader,
  logo,
  user,
  search,
});
